import { useEffect, useState } from 'react';
import EmptySection from './EmptySection';
import styles from './LatestUpdates.module.css';

const PREVIEW_COUNT = 3;

const LatestUpdates = ({ updates, selectedId, onSelect }) => {
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setShowAll(false);
  }, [updates]);

  const hasMore = updates?.length > PREVIEW_COUNT;
  const visibleUpdates = showAll
    ? updates
    : (updates || []).slice(0, PREVIEW_COUNT);

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Latest Updates</h3>
      {!updates?.length ? (
        <EmptySection />
      ) : (
        <>
          <div className={styles.updatesList}>
            {visibleUpdates.map((update) => (
              <div
                key={update.id}
                className={`${styles.updateItem} ${
                  selectedId === update.id ? styles.updateItemSelected : ''
                }`}
                onClick={() => onSelect(update)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onSelect(update)}
              >
                <div className={styles.thumbnail}>
                  {update.thumbnailUrl ? (
                    <img
                      src={update.thumbnailUrl}
                      alt={update.name || update.naslov}
                      className={styles.thumbnailImg}
                    />
                  ) : update.hasVideo ? (
                    <>
                      <i className="fas fa-file-video" />
                      <div className={styles.videoBadge}>
                        <i className="fas fa-play" />
                      </div>
                    </>
                  ) : (
                    <i className="fas fa-file" />
                  )}
                </div>
                <div className={styles.updateContent}>
                  <div className={styles.updateMeta}>
                    {update.datum}
                    {update.kategorija ? ` • ${update.kategorija}` : ''}
                  </div>
                  <h4 className={styles.updateTitle}>{update.naslov}</h4>
                  <p className={styles.updateDesc}>{update.opis}</p>
                </div>
              </div>
            ))}
          </div>
          {hasMore && (
            <button
              type="button"
              className={styles.viewAllBtn}
              onClick={() => setShowAll((curr) => !curr)}
            >
              {showAll ? 'Show less' : 'View all updates'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default LatestUpdates;
